import { apiDataManagerBaseURL } from '../../authentication/Global';
import { authenticationCentral } from '../../authentication/Authentication';
import { API, HTTPMethod, ContentType } from '../APICentral';

const zonesApiRoutes = {
    list: apiDataManagerBaseURL + "zones",
    load: apiDataManagerBaseURL + "zones/",
    create: apiDataManagerBaseURL + "zones",
    update: apiDataManagerBaseURL + "zones/",
    delete: apiDataManagerBaseURL + "zones/"
};

export class ZoneAPI {
    static list(provider = '') {
        return API.authenticatedRequest({
            url: provider === '' ? zonesApiRoutes.list : `${zonesApiRoutes.list}?provider=${provider}`,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static load(id) {
        return API.authenticatedRequest({
            url: zonesApiRoutes.load + id,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static create(zone) {
        return API.authenticatedRequest({
            url: zonesApiRoutes.create,
            method: HTTPMethod.POST,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(zone)
        });
    }

    static update(id, zone) {
        return API.authenticatedRequest({
            url: zonesApiRoutes.update + id,
            method: HTTPMethod.PUT,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(zone)
        });
    }

    static delete(id) {
        return API.authenticatedRequest({
            url: zonesApiRoutes.delete + id,
            method: HTTPMethod.DELETE,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }
}